import { useTranslation } from 'react-i18next';
import { RoutePath } from 'features/routing/constants';
import { useRouteMatch } from 'features/routing/useRouteMatch';
import { NAV_ITEMS } from './navItems';

/** Pattern → label key for every in-shell route: the nav destinations plus the
 *  screens reached from the account menu. */
const labelKeyByPattern = new Map<string, string>([
  ...NAV_ITEMS.map(item => [item.route(), item.labelKey] as [string, string]),
  [RoutePath.SystemInfoWithLayout(), 'SystemInfo'],
  [RoutePath.DevDebugWithLayout(), 'DevDebug'],
  [RoutePath.DevDataExportWithLayout(), 'DevDataExport'],
]);

const titledPatterns = [...labelKeyByPattern.keys()];

/** Title for the current in-shell route — the page `h1` in the shell header. */
export const useRouteTitle = (): string => {
  const { t } = useTranslation();
  const routeMatch = useRouteMatch(titledPatterns);
  const labelKey = labelKeyByPattern.get(routeMatch?.pattern.path ?? '');
  return labelKey === undefined ? '' : t(labelKey);
};
